import { Auth } from '@jg/auth';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { IAppState, ITeamData } from '../../types/state.d';
import ROUTES from '../../consts/routes';
import pushToPage from './pushToPage';
import { getTeamGuid } from '../../selectors/apiSelectors';
import updateTeamName from './updateTeamName';
import createTeam from './createTeam';
import {
  submitTeamNameRequestMade,
  submitTeamNameRequestSuccess,
  submitTeamNameRequestError,
} from '../actionCreators/apiActions';

type submittedTeamNameData = {
  teamName: ITeamData['name'];
};

const submitTeamName = (teamData: submittedTeamNameData) => async (
  dispatch: ThunkDispatch<IAppState, Auth, Action>,
  getState: () => IAppState,
) => {
  try {
    const teamGuid = getTeamGuid(getState());
    dispatch(submitTeamNameRequestMade());
    if (teamGuid) {
      await dispatch(updateTeamName(teamData.teamName));
    } else {
      await dispatch(createTeam(teamData.teamName));
    }
    dispatch(submitTeamNameRequestSuccess());
    dispatch(pushToPage(ROUTES.YOUR_FUNDRAISING_CAUSE));
  } catch (error) {
    dispatch(submitTeamNameRequestError(error.message));
  }
};

export default submitTeamName;
